'use strict';

module.exports = [function () {
     return {
        replace: true,
        scope: true,        
        template: require('./tableButtonGroupEdit.html')
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupEdit.js
// module id = 378
// module chunks = 0